import { CompanyParams } from 'app/models/companies-params'
import * as types from './types'
import { createReducer } from 'app/state/utils'

export interface CompaniesState {
  companies: CompanyParams[]
  isLoading: boolean
}

const initialState: CompaniesState = {
  companies: [],
  isLoading: false,
}

const companiesReducer = createReducer(initialState)({
  [types.GET_COMPANIES]: (state: any, payload: any) => {
    return { ...state, companies: payload.payload }
  },
  [types.START_LOADING_COMPANIES]: (state: CompaniesState) => {
    return { ...state, isLoading: true }
  },
  [types.STOP_LOADING_COMPANIES]: (state: CompaniesState) => {
    return { ...state, isLoading: false }
  },
})

export default companiesReducer
